<template>
  <div class="footer">
    <p>Copyright  ©  2025 All Rights Reserved <span> </span>版权所有：{{$realmNameId==50?'重庆实景城市科技有限公司':'成都和创惠众科技有限公司'}}</p>
    <!--<p style="padding: 10px 0 0;">建议使用谷歌浏览器,最佳分辨率1920*1024浏览</p>-->
    <p style="padding: 10px 0 0;"><a href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备15022041号-3</a> 乙测资字51516514</p>
    <p class="icon-security">
      <i class="icon-img"></i>
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51010802000634" target="_gong">川公网安备 51010802000634号</a>
    </p>
  </div>
</template>

<script>
export default {
  name: 'top',
  data () {
    return {}
  },
  created () {
  },
  mounted () {
  },
  components: {
  },
  methods: {},
  watch: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .footer{
    background-color: #676767;
    text-align: center;
    color: white;
    font-size: 12px;
    padding: 13px 0;
    line-height: 1.2;
    letter-spacing: 1px;
    font-weight: 500;
  }
  .icon-security{
    margin-top: 8px;
  }
  .icon-security i{
    width: 21px;
    height: 21px;
    vertical-align: middle;
    margin-right: 5px;
    background-position: -769px -890px;
  }
  .screen3 .icon-security i{
    background-position: -346px -507px;
    width: 18px;
    height: 18px;
  }
  .screen3 .footer p>span{
    display: block;
    padding:4px 0 0 ;
  }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue